import React, { useMemo, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import axiosService from '../../../utils/AxiosService'
import { toastError } from '../../FormComponents/Toasts'
import { PeopleFill, PersonPlusFill, Heart, Image, CameraVideo, PersonVcard } from 'react-bootstrap-icons'
import { formatNumber } from '../../../utils/Helper'

export default observer(function CampaignInfluencerProfileDetails({
  auth,
  AnalyticsBoxComponent,
  BottomNavComponent = null,
}) {
  const getAuthenticationHistories = authentication => {
    axiosService.get(`/api/project_manager/authentications/${authentication.id}/authentication_histories`)
      .then(authentication_histories => authentication.authentication_histories = authentication_histories)
      .catch(({ data: { error } }) => toastError(error))
  }

  const getHashtags = authentication => {
    axiosService.get(`/api/project_manager/authentications/${authentication.id}/authentications_hashtags`)
      .then(authentications_hashtags => authentication.authentications_hashtags = authentications_hashtags)
      .catch(({ data: { error } }) => toastError(error))
  }

  const realViewRate = useMemo(() => {
    if (auth.authentication_histories.length < 1) return '0.00'
    const latestHistory = auth.authentication_histories[auth.authentication_histories.length - 1]
    const avgReelsPlays = latestHistory.avg_reels_plays
    const followerCount = latestHistory.follower_count

    if (!avgReelsPlays || !followerCount || followerCount === 0) return '0.00'

    return (avgReelsPlays / followerCount * 100).toFixed(2)
  }, [auth.id, auth.authentication_histories.length])

  const followerGrowth = useMemo(() => {
    if (auth.authentication_histories.length < 2) return ''
    const currentFollowerCount = auth.authentication_histories[auth.authentication_histories.length - 1].follower_count
    const previousFollowerCount = auth.authentication_histories[auth.authentication_histories.length - 2].follower_count
    return ((currentFollowerCount - previousFollowerCount) / previousFollowerCount * 100).toFixed(2)
  }, [auth.id, auth.authentication_histories.length])

  useEffect(() => {
    getAuthenticationHistories(auth)
    getHashtags(auth)
  }, [auth.id])

  return (
    <div className="h-full p-7 pt-0 overflow-y-auto">
      <div className="min-h-min pb-24">
        <p className="font-bold text-xl mb-4">Bio and description</p>
        <div className="flex flex-col gap-2">
          <div className="border-1 rounded-lg p-4 h-full flex items-center">
            <p>{auth.bio}</p>
          </div>
          <div className="border-1 rounded-lg p-4">
            <p className="text-sm mb-4">{auth.description || 'No Description.'}</p>
            <div className="flex flex-wrap gap-2">
              {auth.authentications_hashtags.map(({ hashtag: { name } }, index) => (
                <p key={`${name}${index}`} className="bg-gray-100 rounded-md font-semibold text-xs px-2">#{name}</p>
              ))}
            </div>
          </div>
        </div>

        <div className="w-full mt-4">
          <p className="font-bold text-xl mb-4">Analytics</p>
          <div className="grid grid-cols-2 gap-4">
            <div className="p-2 border-1 border-border-primary rounded-lg">
              <AnalyticsBoxComponent text="Followers" icon={<PeopleFill/>} value={formatNumber(auth.reach)} />
            </div>
            <div className="p-2 border-1 border-border-primary rounded-lg">
              <AnalyticsBoxComponent text="Follower growth" icon={<PersonPlusFill />} value={`${followerGrowth}%`}/>
            </div>
            <div className="p-2 border-1 border-border-primary rounded-lg">
              <AnalyticsBoxComponent text="Engagement rate" icon={<Heart />} value={`${(+auth.engagement_rate * 100).toFixed(2)}%`} />
            </div>
            <div className="p-2 border-1 border-border-primary rounded-lg">
              <AnalyticsBoxComponent text="Postings per week" icon={<Image />}/>
            </div>
            <div className="p-2 border-1 border-border-primary rounded-lg">
              <AnalyticsBoxComponent text="Reel view rate" icon={<CameraVideo />} value={`${realViewRate}%`}/>
            </div>
            <div className="p-2 border-1 border-border-primary rounded-lg">
              <AnalyticsBoxComponent text="Audience Age Group" icon={<PersonVcard />} value={auth.age_group} />
            </div>
          </div>
        </div>
        {BottomNavComponent && <BottomNavComponent />}
      </div>
    </div>
  )
})
